import React from 'react';
const TableMeasureRowContext = /*#__PURE__*/React.createContext(false);
export default TableMeasureRowContext;